module.exports = __webpack_public_path__ + "img/12.23f24fa.png";